import React, { useEffect } from 'react';
import { Main } from '@components/Main';
import { LogoContainer } from '@components/Logo';
import { withTrans } from '@i18n/withTrans';

const Logo = ({ i18n, pageContext }) => {
  
  useEffect(() => {
    i18n.changeLanguage(pageContext.lang)
  }, [i18n, pageContext])
  
  return (
    <Main pageContext={pageContext}>
      <LogoContainer/>
    </Main>
  )
}

const LogoPage = withTrans(Logo);

export default LogoPage 
